import * as api from "../api/writtenContribution";

export const sortCommentsByDate = (comments: any[]) => {
  return [...comments].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
};

export const handleAddCommentHelper = async (
  publicationId: string,
  newCommentText: string,
  token: string,
  setComments: (comments: any[]) => void,
  setNewCommentText: (text: string) => void,
  setError: (err: string | null) => void
) => {
  const text = newCommentText.trim();
  if (!text) return;

  try {
    const updated = await api.callAddComment(publicationId, text, token);
    const sorted = sortCommentsByDate(updated.comments || []);
    setComments(sorted);
    setNewCommentText("");
  } catch (err: any) {
    console.error("Failed to add comment:", err);
    setError(err?.response?.data?.message || "Failed to add comment");
  }
};

export const handleEditCommentHelper = async (
  publicationId: string,
  commentId: string,
  text: string,
  token: string,
  setComments: (comments: any[]) => void,
  setActiveCommentId: (id: string | null) => void,
  setError: (err: string | null) => void
) => {
  try {
    const updated = await api.callEditComment(publicationId, commentId, text, token);
    const sorted = sortCommentsByDate(updated.comments || []);
    setComments(sorted);
    setActiveCommentId(null);
  } catch (err: any) {
    console.error("Failed to edit comment:", err);
    setError(err?.response?.data?.message || "Failed to edit comment");
  }
};

export const handleDeleteCommentHelper = async (
  publicationId: string,
  commentId: string,
  token: string,
  setComments: (comments: any[]) => void,
  setActiveCommentId: (id: string | null) => void,
  setError: (err: string | null) => void
) => {
  try {
    const updated = await api.callDeleteComment(publicationId, commentId, token);
    const sorted = sortCommentsByDate(updated.comments || []);
    setComments(sorted);
    setActiveCommentId(null);
  } catch (err: any) {
    console.error("Failed to delete comment:", err);
    setError(err?.response?.data?.message || "Failed to delete comment");
  }
};
